<script>
import {
  QcVersionServiceProxy,
  ProductionCraftServiceProxy,
  QcProcessServiceProxy
} from '@/service-proxies/app-v2/product.service-proxies'
const pcfsp = new ProductionCraftServiceProxy()
const qcvsp = new QcVersionServiceProxy()
const qcpsp = new QcProcessServiceProxy()

import CreatVersion from './CreatVersion'
import ProcedureTable from './ProcedureTable'
import QualityTable from './QualityTable'
import CopyVersion from './CopyVersion'

export default {
  components: {
    CreatVersion,
    ProcedureTable,
    QualityTable,
    CopyVersion
  },
  data() {
    return {
      craftList: [],
      versionList: [],
      selectedVersionId: '',
      creatVisible: false,
      copyVisible: false,
      copyVersionItem: {},
      qcVersionDTO: [],
      qcProcess: {
        current: 1,
        size: 10
      },
      qcProcessData: [],
      qcProcessSelected: '',
      craftId: '',
      qcTotal: 0,
      count: 1,
      selectedRowKeys: [],
      qualityData: {},
      loading: {
        save: false
      },
      nextVersion: '', // 下个版本ID
      creatVersion: false,
      scrollY: 200,
      scrollYs: 200
    }
  },
  props: {
    productId: {
      type: String,
      default: ''
    }
  },
  watch: {
    productId: {
      handler() {
        this.nextVersion = ''
        this.getCraftList()
      },
      deep: true,
      immediate: true
    }
  },
  // created() {
  //   this.getCraftList()
  // },
  methods: {
    handleSave() {
      this.loading.save = true
      const addItems = []
      const qcProcessData = JSON.parse(JSON.stringify(this.qcProcessData))
      Object.keys(this.qualityData).forEach((key) => {
        const data = qcProcessData.find((res) => res.id === key)
        if (data) {
          addItems.push(data)
        }
      })
      if (addItems && addItems.length) {
        let pass = false
        const addBody = []
        addItems.forEach((res) => {
          if (res.processCode == '' || res.processName == '') {
            pass = true
          }
          const qcItemDTOList = []
          const qualityData = JSON.parse(JSON.stringify(this.qualityData[res.id]))
          if (qualityData && qualityData.length) {
            qualityData.forEach((res) => {
              if (res.name == '' || res.standardValue == '') {
                pass = true
              }
              delete res.id
              qcItemDTOList.push(res)
            })
          }
          if (res.id.indexOf('add') != -1) {
            delete res.id
          }
          if (this.selectedVersionId.indexOf('copy') !== -1) {
            const dto = {
              qcItemVOList: qcItemDTOList,
              qcProcessCopyVO: res,
              qcVersionId: ''
            }
            addBody.push(dto)
          } else {
            const dto = {
              qcItemDTOList: qcItemDTOList,
              qcProcessDTO: res,
              qcVersionId: this.selectedVersionId
            }
            addBody.push(dto)
          }
        })
        if (pass) {
          this.$message.warning(this.$t('page_bussiness_data_quality_please_check_to'))
          this.loading.save = false
          return
        }
        if (this.selectedVersionId.indexOf('copy') !== -1) {
          const qcVersionCopyDTO = {
            qcProcessItemCopyDTOList: addBody,
            qcVersionDTO: this.copyVersionItem
          }
          qcvsp
            .copyQcVersion(qcVersionCopyDTO)
            .then(() => {
              this.$message.success('复制成功')
              this.loading.save = false
              this.getCraftList()
            })
            .catch(() => {
              this.loading.save = false
            })
        } else {
          qcpsp
            .createOrUpdateQcProcess(addBody)
            .then(() => {
              this.$message.success(this.$t('page_user_management_new_success'))
              this.loading.save = false
              this.reload()
            })
            .catch(() => {
              this.loading.save = false
            })
        }
      } else {
        this.loading.save = false
      }
    },
    async handleDelete() {
      const addKeys = this.selectedRowKeys.filter((res) => res.indexOf('add') != -1)
      if (addKeys && addKeys.length) {
        addKeys.forEach((res) => {
          this.onDelete(res)
        })
      }
      const deleteKeys = this.selectedRowKeys.filter((res) => res.indexOf('add') === -1)
      if (deleteKeys && deleteKeys.length) {
        const res = qcpsp.deleteQcProcess(deleteKeys)
        deleteKeys.forEach((res) => {
          this.onDelete(res)
        })
      }
      if (this.qcProcessData.length === 0) {
        this.reload()
      }
    },
    reload() {
      this.qcProcessData = []
      this.qualityData = {}
      this.qcProcessSelected = ''
      this.selectedRowKeys = []
      this.qcProcess.current = 1
      this.getQcProcess()
    },
    async handleCreat() {
      this.versionList = await pcfsp.getProductionCraftByProduct(this.productId)
      this.creatVisible = true
    },
    closeVersion() {
      this.creatVisible = false
    },
    saveVersion() {
      this.creatVisible = false
      this.creatVersion = true
      this.getCraftList()
    },
    async handleCopy() {
      this.versionList = await pcfsp.getProductionCraftByProduct(this.productId)
      this.copyVisible = true
    },
    async saveCopy(version) {
      const has = this.craftList.find((res) => res.version === version.craftVersion)
      if (has) {
        this.$message.warning('不能关联相同版本')
        return
      }
      this.copyVersionItem = version
      this.qcProcessData = []
      this.qualityData = {}
      const res = await qcpsp.getQcProcessAndItem(this.selectedVersionId)
      if (res && res.length) {
        res.forEach((item, index) => {
          const qcProcessCopyVO = item.qcProcessCopyVO
          const id = index + 'add'
          const newData = {
            id: id,
            processCode: qcProcessCopyVO.processCode,
            processName: qcProcessCopyVO.processName,
            processSequence: qcProcessCopyVO.processSequence,
            processSort: qcProcessCopyVO.processSort
          }
          this.qcProcessData.push(newData)
          this.qualityData[id] = item.qcItemVOList.map((res, index) => {
            res.id = index + 'add'
            return res
          })
        })
      }
      const nextVersion = await qcvsp.getNextVersion(this.productId)
      this.nextVersion = nextVersion
      const item = {
        craftId: 'copy001',
        id: 'copy001',
        version: nextVersion
      }
      this.craftList.push(item)
      this.selectedVersionId = item.id
      this.qcProcessSelected =
        this.qcProcessData && this.qcProcessData.length ? this.qcProcessData[0].id : ''
      this.craftId = version.craftId
      this.copyVisible = false
    },
    closeCopy() {
      this.copyVisible = false
    },
    async getCraftList() {
      this.craftList = []
      this.copyVersionItem = {}
      this.qcProcessData = []
      this.qualityData = {}
      this.qcProcessSelected = ''
      this.selectedRowKeys = []
      this.qcProcess.current = 1
      this.selectedVersionId = ''
      this.craftId = ''
      if (!this.productId) {
        return
      }
      const res = await qcvsp.getPageQcVersion(this.productId)
      this.craftList = res
      if (res && res.length && this.creatVersion) {
        console.log(res[res.length - 1])
        this.selectCraft(res[res.length - 1].id)
        this.creatVersion = false
      } else if (res && res.length && this.nextVersion === '') {
        this.selectCraft(res[0].id)
      } else if (res && res.length && this.nextVersion != '') {
        const select = res.find((res) => res.version === this.nextVersion)
        if (select) {
          this.selectCraft(select.id)
          this.nextVersion = ''
        }
      } else {
        this.selectedVersionId = ''
        this.craftId = ''
      }
      this.gitScroll()
    },
    gitScroll() {
      const div = document.getElementById('quality-content')
      if (div && div.clientHeight) {
        this.scrollY = div.clientHeight - 95
        this.scrollYs = div.clientHeight - 68
      }
    },
    selectCraft(value) {
      this.selectedVersionId = value
      const craf = this.craftList.find((res) => res.id === value)
      if (craf) {
        this.craftId = craf.craftId
      }
      this.reload()
    },
    async getQcProcess() {
      this.qcProcessData = []
      const res = await qcpsp.getPageQcProcess(
        this.qcProcess.current,
        this.selectedVersionId,
        this.qcProcess.size
      )
      this.qcProcessData = res.records
      this.qcTotal = Number(res.total)
      if (res.records && res.records.length) {
        this.qcProcessSelected = res.records[0].id
      }
    },
    handleTableChange(value) {
      this.qcProcess.current = value
      this.qcProcessSelected = ''
      this.getQcProcess()
    },
    changePorcessTable(value) {
      this.selectedRowKeys = value
    },
    handleAdd() {
      const { count, qcProcessData } = this
      const newData = {
        id: count + 'add',
        processCode: '',
        processName: '',
        processSequence: '',
        processSort: ''
      }
      this.qcProcessData = [...qcProcessData, newData]
      this.qcProcessSelected = newData.id
      this.qualityData[newData.id] = []
      this.count = count + 1
    },
    onDelete(key) {
      const qcProcessData = [...this.qcProcessData]
      this.qcProcessData = qcProcessData.filter((item) => item.id !== key)
    },
    handleChange(value, key, column) {
      const newData = [...this.qcProcessData]
      const target = newData.find((item) => key === item.id)
      if (target) {
        target[column] = value
        this.qcProcessData = newData
      }
    },
    customRow(value) {
      this.qcProcessSelected = value.id
    },
    async deleteCraft(ids) {
      const res = await qcvsp.deleteQcVersion([ids])
      this.$message.success(this.$t('delete_success'))
      this.nextVersion = ''
      this.getCraftList()
    },
    addQualityData(data) {
      this.qualityData[this.qcProcessSelected] = data
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  }
}
</script>

<template>
  <div style="height: 100%">
    <div class="quality-header">
      <div>
        <a-button
          :disabled="qcProcessData.length === 0"
          style="margin-right: 8px"
          :loading="loading.save"
          type="primary"
          @click="handleSave"
          v-acl="'page_product_plan_quality_save'"
        >
          {{ $t('save') }}
        </a-button>
        <a-popconfirm
          v-acl="'page_product_plan_quality_delete'"
          :disabled="selectedRowKeys.length === 0"
          :title="$t('page_resource_pool_confirm_delete')"
          @confirm="handleDelete"
        >
          <a-button
            v-acl="'page_product_plan_quality_delete'"
            type="danger"
            :disabled="selectedRowKeys.length === 0"
          >
            {{ $t('delete') }}
          </a-button>
        </a-popconfirm>
      </div>
      <div>
        <a-button
          v-acl="'page_product_plan_quality_copy_version'"
          style="margin-right: 8px"
          type="default"
          @click="handleCopy"
          :disabled="selectedVersionId === ''"
        >
          {{ $t('copy') }}
        </a-button>
        <a-select
          :value="selectedVersionId"
          style="width: 100px;margin-right: 8px"
          option-label-prop="label"
          show-search
          :filter-option="filterOption"
          @change="selectCraft"
        >
          <template v-for="craft in craftList">
            <a-select-option
              :value="craft.id"
              :key="craft.id"
              class="craft-selection"
              :label="craft.version"
            >
              {{ craft.version }}
              <a-icon
                class="del-craft del-color"
                type="delete"
                v-if="craft.id.indexOf('copy') === -1"
                @click.stop="deleteCraft(craft.id)"
              />
            </a-select-option>
          </template>
        </a-select>
        <a-button
          v-acl="'page_product_plan_quality_creat_version'"
          type="default"
          @click="handleCreat"
        >
          {{ $t('page_business_data_add_process_version') }}
        </a-button>
      </div>
    </div>
    <div class="quality-content" id="quality-content">
      <div style="width: 50%;height100%;padding: 4px 8px;border-right:1px solid #d8d8d8">
        <ProcedureTable
          :selectedId="qcProcessSelected"
          :dataSource="qcProcessData"
          :total="qcTotal"
          :craftId="craftId"
          :filter="qcProcess"
          :selectedRowKeys="selectedRowKeys"
          :scrollY="scrollY"
          @handleTableChange="(value) => handleTableChange(value)"
          @onChange="(value) => changePorcessTable(value)"
          @handleAdd="handleAdd"
          @customRow="(value) => customRow(value)"
          @handleChange="(value, key, column) => handleChange(value, key, column)"
        ></ProcedureTable>
      </div>
      <div style="width: 50%;height100%;padding: 4px 8px">
        <QualityTable
          :selectedId="qcProcessSelected"
          :qualityData="qualityData"
          :scrollY="scrollYs"
          @addQualityData="(value) => addQualityData(value)"
        ></QualityTable>
      </div>
    </div>
    <creat-version
      :visible="creatVisible"
      :versionList="versionList"
      :productId="productId"
      @save="(value) => this.saveVersion(value)"
      @close="() => this.closeVersion()"
    ></creat-version>
    <copy-version
      :visible="copyVisible"
      :versionList="versionList"
      :productId="productId"
      :qcVersionDTO="qcVersionDTO"
      @save="(version) => this.saveCopy(version)"
      @close="() => this.closeCopy()"
    ></copy-version>
  </div>
</template>

<style scoped lang="less">
.quality-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  border-bottom: 1px solid #d8d8d8;
}
.quality-content {
  height: calc(100% - 41px);
  display: flex;
}
.craft-selection {
  position: relative;

  &:hover {
    .del-craft {
      opacity: 1;
    }
  }

  .del-craft {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.3s;
    opacity: 0;
  }
}
</style>
